import { render, staticRenderFns } from "./DueDiligenceExemptionSettings.vue?vue&type=template&id=295bd6a1&scoped=true&"
import script from "./DueDiligenceExemptionSettings.vue?vue&type=script&lang=js&"
export * from "./DueDiligenceExemptionSettings.vue?vue&type=script&lang=js&"
import style0 from "./DueDiligenceExemptionSettings.vue?vue&type=style&index=0&id=295bd6a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295bd6a1",
  null
  
)

export default component.exports